export default {
  nav: {
    main: 'Huvudmeny',
    ordersAndInvoices: 'Ordrar och fakturor',
    drafts: 'Utkast',
    automation: 'Automatisering',
    workspace: 'Arbetsyta',
    templates: 'Mallar',
    delivery: 'Leverans',
    settings: 'Inställningar',
    shippingLabels: 'Fraktetiketter',
    subscriptions: 'Prenumerationer',
    support: 'Support',
    developer: 'Utvecklare',
    writeReview: 'Skriv en recension',
    supportTicket: 'Supportärende',
    welcomeTour: 'Välkomstguide',
    administratorConsole: 'Administratörskonsol',
    logout: 'Logga ut',
  },
  dashboard: {
    pageTitle: 'Ordrar och fakturor',
    pageDescription: 'Manage your orders and invoices',
    title: 'Ordrar och fakturor',
    selectedOrders: '{count} valda ordrar',
    completed: '% slutfört',
    processing: 'Bearbetar, vänta...',
    bulkDownload: 'Massnedladdning',
    upgradeBulkDownload: 'Uppgradera din plan för massnedladdning',
    showFilters: 'Visa filter',
    hideFilters: 'Dölj filter',
    creatingInvoices: 'Skapar fakturor, vänta...',
    bulkCreateInvoices: 'Skapa fakturor i bulk',
    cannotCreateAutopilot: 'Du kan inte skapa fakturor manuellt när faktureringsläget är på autopilot.',
    exportInvoices: 'Exportera fakturor eller ordrar',
    capturePayments: 'Fånga betalningar manuellt',
    filterOrders: 'Filtrera ordrar',
    error: 'Hoppsan, något gick fel...',
    close: 'Stäng',
    chooseDate: 'Välj ett datum',
    chooseIssueDate: 'Välj ett utfärdandedatum för de valda fakturorna',
    cancel: 'Avbryt',
    createInvoices: 'Skapa fakturor',
    storno: 'Storno',
    bulkOrderCapture: 'Massregistrering av ordrar',
  },
  search: {
    createdBetween: 'Skapad mellan',
    modifiedBetween: 'Ändrad mellan',
    orderNumber: 'Order #',
    invoiceNumber: 'Faktura #',
    refundNumber: 'Återbetalning #',
    customer: 'Kund',
    payment: 'Betalning',
    any: 'Alla',
    authorized: 'Auktoriserad',
    pending: 'Väntande',
    paid: 'Betald',
    partiallyPaid: 'Delvis betald',
    refunded: 'Återbetald',
    voided: 'Ogiltig',
    partiallyRefunded: 'Delvis återbetald',
    unpaid: 'Obetald',
    fulfillment: 'Uppfyllelse',
    fulfilled: 'Levererad',
    partial: 'Delvis',
    unfulfilled: 'Ej levererad',
    loading: 'Laddar ordrar...',
    search: 'Sök',
  },
  orderList: {
    noCustomer: 'Ingen kund',
    downloadOrder: 'Ladda ner order',
    deleteWarning: 'Viktigt! Detta kommer att radera alla fakturor och återbetalningar skapade efter datumet:',
    includingInvoice: 'inklusive den valda fakturan #',
    pressOk: 'Tryck OK för att fortsätta eller Avbryt för att avbryta.',
    cannotCreateAutopilot: 'Du kan inte skapa fakturor manuellt när faktureringsläget är på autopilot.',
    createInvoice: 'Skapa faktura för denna order',
    create: 'Skapa',
    addCreditNote: 'Lägg till kreditnota',
    createStorno: 'Skapa en stornofaktura',
    refund: 'Återbetalning',
    downloadInvoice: 'Ladda ner denna faktura',
    download: 'Ladda ner',
    default: 'Standard',
    downloadStorno: 'Ladda ner denna storno-/kreditnota',
    fulfillOrder: 'Uppfyll order',
    orderNum: 'Order #',
    locPrefix: 'Platsprefix',
    invoiceNum: 'Faktura #',
    refundNum: 'Återbetalning #',
    customerCol: 'Kund',
    orderCreatedDate: 'Order skapad datum',
    orderModifiedDate: 'Order ändrad datum',
    delivered: 'Levererad',
    paymentStatus: 'Betalningsstatus',
    fulfillmentStatus: 'Leveransstatus',
    totalOutstanding: 'Totalt utestående belopp',
    originalPrice: 'Originalpris',
    noOrders: 'Din butik har inga ordrar för den valda statusen.',
    cannotCreateNoOrders: 'Du kan inte skapa fakturor när det inte finns några ordrar.',
    createOrdersFirst: 'Skapa minst en order och försök igen.',
    createOrders: 'Skapa ordrar',
    loadingOrders: 'Laddar...',
    paidManual: 'Betald - Manuell',
    paid: 'Betald',
    refunded: 'Återbetald',
    pending: 'Väntande',
    partiallyPaid: 'Delvis betald',
    partiallyRefunded: 'Delvis återbetald',
    fulfilled: 'Levererad',
    unfulfilled: 'Ej levererad',
    deliveryPending: 'Väntande',
    deliverNow: 'Leverera nu',
    deliveryPartial: 'Delvis',
    notDelivered: 'Ej levererad',
    deliverAgain: 'Leverera igen',
    deliveryDetails: 'Leveransdetaljer',
    deliveryFailed: 'Leverans misslyckades',
    sent: 'Skickad',
    failed: 'Misslyckades',
    toLabel: 'Till',
    folderLabel: 'Mapp',
    open: 'Öppen',
    invoice: 'Faktura',
    creditNote: 'Kreditnota',
    stornoLabel: 'Storno',
    unknown: 'Okänd',
    googleDrive: 'Google Drive',
    clientsTablet: 'Kundtablett',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-post',
    ftpChannel: 'FTP',
    revertToDate: 'Återställ till detta datum',
    add: 'Lägg till',
    close: 'Stäng',
  },
  downloadDialog: {
    downloadType: 'Ladda ner {type}...',
    selectTemplate: 'Välj en mall från galleriet för att exportera ordrar, fakturor, stornofakturor eller kreditnotor.',
    getMoreTemplates: 'Hämta fler mallar',
    createNewTemplate: 'Skapa en ny mall',
    allCreatedBetween: 'Alla skapade {type} mellan',
    selectedType: 'Valda {type}',
    and: 'och',
    status: 'Status',
    any: 'Alla',
    open: 'Öppen',
    closed: 'Stängd',
    cancelled: 'Avbruten',
    paymentStatus: 'Betalningsstatus',
    fulfillmentStatus: 'Leveransstatus',
    fulfilled: 'Levererad',
    partial: 'Delvis',
    unfulfilled: 'Ej levererad',
    authorized: 'Auktoriserad',
    pending: 'Väntande',
    paid: 'Betald',
    partiallyPaid: 'Delvis betald',
    refunded: 'Återbetald',
    voided: 'Ogiltig',
    partiallyRefunded: 'Delvis återbetald',
    unpaid: 'Obetald',
    format: 'Format',
    forLocation: 'För plats',
    advancedOptions: 'Avancerade alternativ',
    exportHSCodes: 'Exportera lager HS-koder (långsammare)',
    noteChrome: 'Obs: För optimal nedladdning rekommenderas Chrome och att adblocker inaktiveras.',
    downloadIndividually: 'Ladda ner enskilt',
    downloadGrouped: 'Ladda ner grupperat',
  },
  templates: {
    pageTitle: 'Mallar',
    pageDescription: 'Customize your invoice templates',
    title: 'Mallar',
    installTranslated: 'Installera en översatt mall',
    installTranslatedDesc: 'Välj ett annat språk genom att klicka på den här knappen.',
    createNew: 'Skapa en ny mall vid behov',
    createNewDesc: 'Klicka på den här knappen för att skapa en ny mall vid behov.',
    customize: 'Anpassa mallar',
    customizeDesc: 'Klicka på standardmallen för att anpassa den. Du kan ändra logotyp, färger och för mer avancerade användare, koden bakom.',
    defaultTemplate: 'Faktura, storno och kreditnota (Standard)',
    logo: 'Logotyp',
    colorPalette: 'Färgpalett',
    getColorPalettes: 'Hämta färgpaletter',
    paperSize: 'Pappersstorlek',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientering',
    landscape: 'Liggande',
    portrait: 'Stående',
    margin: 'Marginal (cm)',
    unsavedChanges: 'Osparade ändringar',
    discard: 'Förkasta',
    save: 'Spara',
  },
  labels: {
    pageTitle: 'Fraktetiketter',
    pageDescription: 'Create and manage shipping labels',
    title: 'Fraktetiketter',
    glsRequiresPro: 'GLS fraktetiketter för EEU kräver Professional-planen.',
    upgradeDesc: 'Uppgradera till Professional för att skapa och hantera fraktetiketter.',
    upgradePlan: 'Uppgradera din plan',
    eeuGls: 'EEU GLS',
    enabled: 'Aktiverad',
    country: 'Land',
    hungary: 'Ungern',
    slovakia: 'Slovakien',
    czech: 'Tjeckien',
    romania: 'Rumänien',
    slovenia: 'Slovenien',
    croatia: 'Kroatien',
    senderId: 'Avsändar-ID',
    username: 'Användarnamn',
    password: 'Lösenord',
    name: 'Namn',
    city: 'Stad',
    address: 'Adress',
    zipCode: 'Postnummer',
    contactPerson: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-post',
    glsServices: 'GLS-tjänster',
    expressService: 'Expresstjänst',
    exchangeService: 'Bytestjänst',
    smsService: 'SMS-tjänst',
    smsText: 'SMS-text',
    preAdviceService: 'PreAdvice-tjänst',
    unsavedChanges: 'Osparade ändringar',
    discard: 'Förkasta',
    save: 'Spara',
  },
  billing: {
    pageTitle: 'Fakturering',
    pageDescription: 'Manage your subscription and billing',
    title: 'Fakturering',
    subscriptionFor: 'Prenumerationsplan för butik',
    currentlySubscribed: 'Du prenumererar för närvarande på',
    plan: 'plan',
    cancelSubscription: 'Avsluta prenumeration',
    upgradePlan: 'Uppgradera din plan',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / månad',
    upgrade: 'Uppgradera',
    includesAllStarter: 'Inkluderar alla Starter-funktioner, plus:',
    proFeature1: 'Global efterlevnadssvit: Platsbaserade prefix och anpassad sekventiell numrering',
    proFeature2: 'Smart lokalisering: Automatiskt översatta e-postmeddelanden och lokaliserade PDF-bilagor',
    proFeature3: 'Komplett B2B-dokumentlivscykel: Proformafakturor, B2B-offerter och kreditnotor',
    proFeature4: 'B2B-bokföringssynkronisering: 3-decimalers enhetsprecision och multivalutavisning',
    proFeature5: 'Automatiska säkerhetskopior: Kopiera fakturor automatiskt till säker FTP eller Google Drive',
    proFeature6: 'Shopify Flow: Automatisera fakturagenerering, leverans och storno via Flow-utlösare och åtgärder',
    proFeature7: 'Avancerad AI-logik: Använd den lokala AI:n för komplexa villkorliga layoutklausuler',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X-export (europeisk e-fakturaefterlevnad)',
    proFeature9: 'EPC QR-koder för snabba mobila POS-betalningar',
    proFeature10: 'GLS fraktetiketter för EEU',
    proFeature11: '7 års skattearkivering för efterlevnad',
    currentlyUsing: 'Du använder för närvarande vår',
    free: 'gratis',
    subscriptionPlan: 'prenumerationsplan.',
    monthlyUsage: 'Månatlig användning',
    monthlyGenerated: '{count} / 50 fakturor denna månad',
    monthlyLimitReached: 'Månadsgränsen nådd. Uppgradera till Starter för obegränsade fakturor.',
    freePlan: 'Gratisplan',
    freeToInstall: 'Gratis att installera',
    freeFeature1: 'Upp till 50 fakturor/ordrar per månad',
    freeFeature2: 'Tillgång till alla 31+ fördefinierade mallar',
    freeFeature3: 'Grundläggande AI Copilot',
    freeFeature4: 'Standard PDF-nedladdningar och utskrift',
    freeFeature5: 'Standarddokumentsvit (Fakturor, följesedlar, kvitton)',
    freeFeature6: '3 månaders säker fakturalagring',
    starterPlan: 'Starter-plan',
    starterPrice: '$9.99 / månad',
    starterPricePerInvoice: '+ 3¢ per skapad faktura',
    subscribe: 'Prenumerera',
    starterFeature1: 'Obegränsade fakturor och ordrar',
    starterFeature2: 'Automatisk PDF-leverans via e-post',
    starterFeature3: 'Full tillgång till hybridredigerare och AI Copilot',
    starterFeature4: 'Shopify POS och streckkodsintegration',
    starterFeature5: 'Shopify Flow: Utlösare och åtgärder för fakturaautomatisering',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X-export (e-fakturaefterlevnad)',
    starterFeature7: '1 års säker fakturalagring',
    proTaxOverrides: 'Anpassade skatteåsidosättningar: Moms/GST per produkt och SKU-nivåsatser',
    unsavedChanges: 'Osparade ändringar',
    discard: 'Förkasta',
    save: 'Spara',
  },
  autopilot: {
    pageTitle: 'Automatisering',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatisering',
    autoCreate: 'Skapa fakturor automatiskt',
    disabled: 'Inaktiverad (Manuell)',
    whenCreated: 'När ordrar skapas',
    whenFulfilled: 'När ordrar uppfylls',
    whenPaid: 'När ordrar betalas',
    autoCreateDesc: 'Fakturor skapas på det datum då ordrar skapas, uppfylls eller betalas.',
    autoStorno: 'Stornera fakturor automatiskt',
    whenCancelled: 'När ordrar avbryts eller återbetalas',
    autoStornoDesc: 'Stornofakturor skapas på det datum då ordrar annulleras/avbryts eller återbetalningar skapas.',
    cannotAutoFree: 'Automatiskt skapande av fakturor kan inte utföras med gratisplanen.',
    upgradePlan: 'Uppgradera din plan',
    unsavedChanges: 'Osparade ändringar',
    discard: 'Förkasta',
    save: 'Spara',
  },
  delivery: {
    pageTitle: 'Leverans',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Leverans',
    settings: 'Inställningar',
    useOrderNumbers: 'Använd ordernummer för filer',
    sendIfCountry: 'Skicka om faktureringsadressens land är',
    countryCodesHint: 'Lista alla landskoder separerade med semikolon.',
    sendForTags: 'Skicka för kunder som har en av de listade taggarna',
    tagsHint: 'Lista alla taggar separerade med semikolon.',
    emailDelivery: 'E-postleverans',
    sendAsPdf: 'Skicka fakturor som PDF-bilagor till kunder',
    autoSend: 'Skicka automatiskt när en faktura skapas',
    subject: 'Ämne',
    body: 'Brödtext',
    xmlAttachments: 'XML-bilagor',
    attachUbl: 'Bifoga UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Bifoga ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Skicka testmeddelande',
    sending: 'Skickar...',
    customSmtp: 'Anpassad SMTP-server',
    customSmtpDesc: 'Använd din egen e-postserver istället för standardservern',
    enableSmtp: 'Aktivera anpassad SMTP',
    smtpHost: 'SMTP-värd',
    port: 'Port',
    useSsl: 'Använd SSL/TLS',
    username: 'Användarnamn',
    password: 'Lösenord',
    fromEmail: 'Från e-post',
    fromName: 'Från namn',
    shopifyLiquid: 'Shopify Liquid-mall',
    pasteInto: 'Klistra in detta i din',
    orderConfirmation: 'orderbekräftelsemall',
    toAddLink: 'för att lägga till en nedladdningslänk.',
    downloadInvoice: 'Ladda ner din faktura',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Skicka förfrågningar till ClientsTablet när fakturor skapas',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Skicka PDF-fakturor som tulldokument till ShippyPro för länder utanför EU',
    ftpBackup: 'FTP/SFTP-säkerhetskopiering',
    ftpDesc: 'Kopiera fakturor automatiskt till din server',
    enableFtp: 'Aktivera automatisk FTP-säkerhetskopiering',
    host: 'Värd',
    useSftp: 'Använd SFTP (säker)',
    destinationFolder: 'Målmapp',
    xmlFiles: 'XML-filer',
    includeUbl: 'Inkludera UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Inkludera ZUGFeRD / Factur-X XML',
    testConnection: 'Testa anslutning',
    testing: 'Testar...',
    pro: 'PRO',
    upgradeFtp: 'Uppgradera till Professional för att automatiskt kopiera fakturor till din FTP/SFTP-server.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Synkronisera fakturor automatiskt till din Drive',
    connected: 'Ansluten',
    disconnect: 'Koppla från',
    notWorking: 'Fungerar det inte? Gå till',
    googlePermissions: 'Google-behörigheter',
    removeThenReconnect: 'ta bort Invoice Browse och anslut sedan igen.',
    connectGoogleDrive: 'Anslut Google Drive',
    upgradeGoogleDrive: 'Uppgradera till Professional för att automatiskt synkronisera fakturor till Google Drive.',
    unsavedChanges: 'Osparade ändringar',
    discard: 'Förkasta',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Spara',
  },
  bookkeeping: {
    pageTitle: 'Inställningar',
    pageDescription: 'Configure your invoice settings',
    title: 'Inställningar',
    owner: 'Ägare',
    email: 'E-post',
    phone: 'Telefon',
    keepDifferentNumbering: 'Behåll separat fakturanumrering för varje orderplats',
    keepDifferentNumberingDisabled: 'Separat fakturanumrering för varje orderplats är inte ett alternativ som är aktiverat med din plan.',
    locationEmailDesc: 'Detta gör att du kan skicka e-post och fakturor översatta baserat på orderplatsen: lagerplats, leverans- eller faktureringsadress',
    upgradePlan: 'Uppgradera din plan',
    matchingCriteria: 'Matchningskriterier',
    locationId: 'Plats-ID',
    shippingCountryCode: 'Leveransadressens landskod',
    billingCountryCode: 'Faktureringsadressens landskod',
    matchLocationDesc: 'Matcha en plats baserat på orderplats-ID, leverans- eller faktureringsadressens landskod.',
    companyInfo: 'Företagsinformation',
    name: 'Namn',
    website: 'Webbplats',
    registrationNumber: 'Organisationsnummer',
    taxId: 'Momsregistreringsnummer',
    addressSection: 'Adress',
    streetName: 'Gatunamn',
    streetNumber: 'Gatunummer',
    zip: 'Postnummer',
    city: 'Stad',
    region: 'Region',
    country: 'Land',
    bankingInfo: 'Bankinformation',
    bankName: 'Banknamn',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Fakturering',
    decimalPlaces: 'Decimaler',
    invoicesPrefix: 'Fakturaprefix',
    currentInvoiceNumber: 'Nuvarande fakturanummer',
    creditNotesPrefix: 'Kreditnotaprefix',
    currentCreditNoteNumber: 'Nuvarande kreditnotanummer',
    lastInvoiceDate: 'Senaste fakturadatum',
    noInvoicesYet: 'Inga fakturor skapade ännu.',
    confirmReverting: 'Bekräfta återställning av systemet',
    allInvoicesAfter: 'Alla fakturor och deras storno utfärdade efter',
    willBeRemoved: 'kommer att tas bort. Fortsätt med att återställa systemet?',
    cancel: 'Avbryt',
    revert: 'Återställ',
    revertDesc: 'Att återställa systemet kommer att radera alla fakturor skapade efter det valda datumet.',
    revertToDate: 'Återställ till detta datum',
    reverting: 'Återställer systemet, vänta...',
    useOrderNumbering: 'Använd ordernumrering',
    showVat: 'Visa moms på fakturor',
    overrideTaxes: 'Åsidosätt skatter',
    pricesIncludeTax: 'Priserna inkluderar skatt',
    productsTaxRate: 'Produktskattesats',
    shippingTaxRate: 'Fraktskattesats',
    skusSeparated: 'SKU:er separerade med semikolon',
    skusTaxRate: 'SKU-skattesats',
    useOrderDates: 'Använd orderskapandedatum för fakturor',
    convertCurrency: 'Konvertera priser till den valuta kunden betalar i',
    unsavedChanges: 'Osparade ändringar',
    discard: 'Förkasta',
    save: 'Spara',
  },
  drafts: {
    pageTitle: 'Utkast',
    pageDescription: 'Manage your draft orders',
    title: 'Utkast',
    download: 'Ladda ner',
    newDraft: 'Nytt utkast',
    exporting: 'Exporterar {status}%...',
    accessNotGranted: 'Åtkomst till utkastordrar ej beviljad. Vänligen',
    reLogin: 'logga in igen',
    toGrantPermissions: 'för att bevilja de nödvändiga behörigheterna för "Utkastordrar".',
    pushFailed: 'Överföring till Shopify misslyckades:',
    exportError: 'Exportfel:',
    confirmDelete: 'Är du säker på att du vill radera detta utkast?',
    incompleteCustomer: 'Kunddata är ofullständig:',
    pushWithoutCustomer: 'Utkastet kommer att skickas till Shopify utan kunddata. Fortsätt?',
    customerNotInShopify: 'Denna kund finns inte i Shopify ännu.',
    warnings: 'Varningar:',
    createCustomerAndPush: 'Skapa kunden i Shopify och skicka utkastordern?',
    downloadTitle: 'Ladda ner utkast',
    cancel: 'Avbryt',
  },
  draftEdit: {
    number: "Nummer",
    prefix: "Prefix",

    newDraft: 'Nytt utkast',
    editDraft: 'Redigera utkast',
    viewInShopify: 'Visa i Shopify',
    back: 'Tillbaka',
    createDraft: 'Skapa utkast',
    saveChanges: 'Spara ändringar',
    documentType: 'Dokumenttyp',
    draftOrder: 'Utkastorder',
    quote: 'Offert',
    proforma: 'Proforma',
    manualInvoice: 'Manuell faktura',
    currency: 'Valuta',
    expiryDate: 'Utgångsdatum',
    status: 'Status',
    draft: 'Utkast',
    sent: 'Skickad',
    accepted: 'Accepterad',
    customer: 'Kund',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    email: 'E-post',
    phone: 'Telefon',
    company: 'Företag',
    taxId: 'Momsregistreringsnummer',
    billingAddress: 'Faktureringsadress',
    address: 'Adress',
    aptSuite: 'Lägenhet/Svit',
    city: 'Stad',
    province: 'Län',
    countryField: 'Land',
    zip: 'Postnummer',
    shippingAddress: 'Leveransadress',
    sameAsBilling: 'Samma som fakturering',
    lineItems: 'Radposter',
    shipping: 'Frakt',
    shippingTitle: 'Titel',
    shippingPlaceholder: 't.ex. Standardfrakt',
    price: 'Pris',
    note: 'Anteckning',
    notePlaceholder: 'Intern anteckning eller meddelande till kund...',
    summary: 'Sammanfattning',
    subtotal: 'Delsumma',
    discounts: 'Rabatter',
    tax: 'Skatt',
    total: 'Totalt',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Ange din butiksadress',
    loginWith: 'Logga in med',
    createAccount: 'Skapa ett nytt konto',
    placeholder: 'ditt-butiksnamn',
    shopRequired: 'Butiksnamn krävs',
    login: 'Logga in',
    shopify: 'Shopify',
    terms: 'Villkor',
    privacy: 'Integritetspolicy',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Gillar du Invoice Browse?',
    description: 'Du har skapat dina första fakturor! Om du tycker att appen är användbar hjälper en snabb recension på Shopify App Store oss mycket.',
    reward: 'Som tack återställer vi din månatliga användningsräknare till 0',
    leaveReview: 'Lämna en recension',
    maybeLater: 'Kanske senare',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Välkommen till Invoice Browse',
    welcomeContent: 'Låt mig visa dig hur du kan använda appen.',
    dashboardTitle: 'Instrumentpanel',
    dashboardContent: 'Skärmen du ser är huvudinstrumentpanelen. Här hittar du alla ordrar och kan exportera dem till olika dokumenttyper som: fakturor, följesedlar och andra.',
    automationTitle: 'Gör livet enklare',
    automationContent: 'Aktivera automatisering för att skapa fakturor när ordrar betalas eller återbetalas.',
    templatesTitle: 'Anpassa mallar',
    templatesContent: 'Gå hit för att översätta din mall, anpassa den eller skapa en ny.',
    deliveryTitle: 'Leverans',
    deliveryContent: 'Konfigurera vår app för att automatiskt kopiera skapade dokument till FTP, Google Drive eller som bilagor i e-post.',
    settingsTitle: 'Inställningar',
    settingsContent1: 'Justera företagets telefonnummer, e-post och andra fält som används på dokument.',
    settingsContent2: 'Ändra dokumentets startnummer eller radera dokument skapade efter ett datum.',
    settingsContent3: 'Åsidosätt momssatser för frakt och produkter',
    settingsContent4: 'Ändra antal decimaler för nummer',
    reviewTitle: 'Skriv en recension',
    reviewContent: 'Stöd vårt team genom att skriva en bra recension!',
    tourTitle: 'Välkomstguide',
    tourContent: 'Hej, du kan öppna denna guide igen härifrån.',
    createDocTitle: 'Skapa ditt första dokument',
    createDocContent: 'Klicka på Skapa-knappen för att skapa ditt första dokument.',
    docNumberTitle: 'Dokumentnummer',
    docNumberContent: 'Första dokumentet har nummer 1 tilldelat. Om du vill börja med ett annat nummer kan du ändra detta under Inställningar.',
    downloadDocTitle: 'Ladda ner dokument',
    downloadDocContent: 'Klicka på rullgardinsmenyn Ladda ner och välj en dokumentmall för att exportera din order som PDF.',
  },
  common: {
    save: 'Spara',
    cancel: 'Avbryt',
    close: 'Stäng',
    discard: 'Förkasta',
    delete: 'Radera',
    edit: 'Redigera',
    create: 'Skapa',
    loading: 'Laddar...',
    unsavedChanges: 'Osparade ändringar',
    upgradePlan: 'Uppgradera din plan',
  },
  languageSelector: {
    label: 'Språk',
    auto: 'Identifiera automatiskt',
  },
  draftList: {
    draftNum: 'Utkast #',
    shopifyId: 'Shopify ID',
    type: 'Typ',
    customer: 'Kund',
    total: 'Totalt',
    status: 'Status',
    delivered: 'Levererad',
    date: 'Datum',
    actions: 'Åtgärder',
    noCustomer: 'Ingen kund',
    noDrafts: 'Inga utkast eller offerter hittades.',
    loading: 'Laddar...',
    download: 'Ladda ner',
    default: 'Standard',
    pending: 'Väntande',
    deliverNow: 'Leverera nu',
    deliveryDetails: 'Leveransdetaljer',
    sent: 'Skickad',
    failed: 'Misslyckad',
    deliverAgain: 'Leverera igen',
    partial: 'Delvis',
    notDelivered: 'Ej levererad',
    deliveryFailed: 'Leverans misslyckades',
    unknown: 'Okänd',
    edit: 'Redigera',
    send: 'Skicka',
    pushToShopify: 'Skicka till Shopify',
    complete: 'Slutför',
    duplicate: 'Duplicera',
    delete: 'Ta bort',
    quote: 'Offert',
    proforma: 'Proforma',
    draftOrder: 'Utkastorder',
    manualInvoice: 'Manuell faktura',
  },
  draftSearch: {
    createdBtw: 'Skapad ml.',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Kund',
    status: 'Status',
    type: 'Typ',
    delivery: 'Leverans',
    any: 'Alla',
    draft: 'Utkast',
    sent: 'Skickad',
    accepted: 'Accepterad',
    expired: 'Utgången',
    converted: 'Konverterad',
    cancelled: 'Avbruten',
    quote: 'Offert',
    proforma: 'Proforma',
    draftOrder: 'Utkastorder',
    manualInvoice: 'Manuell faktura',
    delivered: 'Levererad',
    notDelivered: 'Ej levererad',
    pending: 'Väntande',
    search: 'Sök',
  },
  draftDownload: {
    title: 'Ladda ner Utkast #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Status',
    documentType: 'Typ',
    any: 'Alla',
    draft: 'Utkast',
    sent: 'Skickad',
    accepted: 'Accepterad',
    expired: 'Utgången',
    converted: 'Konverterad',
    cancelled: 'Avbruten',
    quote: 'Offert',
    proforma: 'Proforma',
    draftOrder: 'Utkastorder',
    manualInvoice: 'Manuell faktura',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Installera ny mall',
    tabStyle: 'Stil',
    tabContent: 'Innehåll',
    tabTranslations: 'Översättningar',
    tabSettings: 'Inställningar',
    tabCode: 'Kod',
    tabCopilot: 'AI-Kopilot',
    logo: 'Logotyp',
    colorPalette: 'Färgpalett',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/sv.js